<template>
	<a class="v-image" :style="contentStyle" :href="target&&image.src" :loading="loading&&''" :target="target" @click="'proview' in $attrs&&$refs.proview.open()">
		<div class="v-image-inner" :style="innerStyle" ref="inner"></div>
    <div class="v-image-content">
      <slot/>
    </div>
    <v-dialog ref="proview" closable>
      <img :src="image.src"/>
    </v-dialog>
	</a>
</template>

<script>
export default {
  props: {
    src: {
      default: ""
    },
    origin: {
      default: ""
    },
    size: {
      default: "100% 100%"
    },
    width: {
      default: ""
    },
    height: {
      default: ""
    },
    radius: {
      default: ""
    }
  },
  data() {
    return {
      loadState: -1,
      loading: false,
      innerStyle: {},
      contentStyle: {},
      image: Object.assign(new Image(), {
        onload: () => {
          let ratio = 1,
            { width, height } = this.image,
            { offsetWidth, offsetHeight } = this.$refs.inner;
          if (height) ratio = width / height;
          if (offsetWidth && offsetHeight) {
            (width = offsetWidth), (height = offsetHeight);
          } else if (!offsetWidth && offsetHeight) {
            (width = offsetHeight * ratio), (height = offsetHeight);
          } else if (!offsetHeight && offsetWidth) {
            (height = offsetWidth / ratio), (width = offsetWidth);
          }
          this.innerStyle = {
            borderRadius: this.radius,
            backgroundSize: this.size,
            width: "100%",
            height: "100%",
            backgroundImage: `url("${this.image.src}")`
          };
          this.contentStyle = {
            width: this.$filter.unit(width, "px"),
            height: this.$filter.unit(height, "px")
          };
          this.loadState = 1;
          this.loading = false;
          this.$emit("load");
        },
        onerror: () => {
          if (this.loadState) {
            this.loadState = 0;
            this.loading = false;
            if ("def" in this.$attrs) {
              this.load(this.$attrs.def || this._config.default);
            }
            this.$emit("error");
          }
        }
      })
    };
  },
  computed: {
    target() {
      return this.$attrs.target || false;
    }
  },
  watch: {
    src(value) {
      this.loading = true;
      this.load(value);
    }
  },
  methods: {
    load(url) {
      let { origin, pathname, search } = this.$url(url);
      this.image.src =
        this.$url.path(
          "self" in this.$attrs
            ? location.origin
            : origin || this.origin || this._config.origin,
          pathname,
          search
        ) +
        (this.width
          ? `?x-oss-process=image/resize,w_${parseInt(this.width)}`
          : "");
    }
  },
  mounted() {
    this.$bindEvents(this.$el);
    this.load(this.src);
    Object.assign(this.$refs.inner.style, {
      width: this.$filter.unit(this.width, "px"),
      height: this.$filter.unit(this.height, "px")
    });
  }
};
</script>

<style lang="less">
.v-image {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  &[proview] {
    cursor: pointer;
  }
  &::before {
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
  > .v-image-inner {
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    position: absolute;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
  > .v-image-content {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/image.vue